<notification-center-component
  [styles]="styles()"
  [subscriberId]="subscriberId"
  [applicationIdentifier]="applicationIdentifier"
  [backendUrl]="backendUrl"
  [popoverConfig]="popoverConfig"
  [subscriberHash]="subscriberHash"
  [showUserPreferences]="showUserPreferences"
  [allowedNotificationActions]="allowedNotificationActions"
  [i18n]="i18n"
  [sessionLoaded]="sessionLoaded"
  [notificationClicked]="notificationClicked"
  [unseenCountChanged]="unseenCountChanged"
  [actionClicked]="actionClicked"
></notification-center-component>
